import { AbiItem } from 'web3-utils';

import { isValidAbi } from 'modules/core';

const ERROR_INCORRECT_ABI = new Error('Incorrect ABI');
export function convertToAbi(value: string): AbiItem[] {
  const parsedValue = JSON.parse(value);
  const isValid = isValidAbi(parsedValue);
  if (!isValid) {
    throw ERROR_INCORRECT_ABI;
  }

  return parsedValue;
}
